<template>
	<div class="full-image" v-if="show">
		<div class="mask" @click="close"></div>
		<div class="image-box">
			<img v-if="displayUrl" :src="displayUrl" @load="onImageLoad" />
		</div>
		<div class="close" @click="close">
			<i class="el-icon-close"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: "fullImage",
	data() {
		return {
			show: false,
			thumbUrl: '',
			originUrl: '',
			originLoaded: false
		}
	},
	computed: {
		displayUrl() {
			if (this.originLoaded) {
				return this.originUrl
			}
			return this.thumbUrl || this.originUrl
		}
	},
	methods: {
		open(imageData) {
			this.show = true
			this.originLoaded = false

			if (typeof imageData === 'string') {
				this.originUrl = imageData
				this.thumbUrl = ''
				this.originLoaded = true
				return
			}

			if (imageData && imageData.originUrl) {
				this.originUrl = imageData.originUrl
				this.thumbUrl = imageData.thumbUrl || ''

				// 如果有缩略图，先显示缩略图，后台预加载高清图
				if (this.thumbUrl && this.thumbUrl !== this.originUrl) {
					this.preloadOriginImage()
				} else {
					this.originLoaded = true
				}
			}
		},

		preloadOriginImage() {
			const img = new Image()
			img.onload = () => {
				if (this.show) {
					this.originLoaded = true
				}
			}
			img.src = this.originUrl
		},

		onImageLoad() {
			// 图片加载完成
		},

		close() {
			this.show = false
			this.thumbUrl = ''
			this.originUrl = ''
			this.originLoaded = false
		}
	}
}
</script>

<style lang="scss">
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.5;
		cursor: pointer;
	}

	.image-box {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100vw;
			height: 100vh;
			object-fit: contain;
		}
	}

	.close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 20px;
		right: 20px;
		cursor: pointer;
		background: #333;
		border-radius: 50%;
		padding: 10px;
		opacity: 0.5;

		i {
			font-weight: bold;
			font-size: 20px;
			color: white;
		}
	}
}
</style>
